<template>
  <v-footer absolute color="#3A1D0F">
      <v-col col-12>
        <v-row align="center" justify="center">
          <div class="white--text caption">&copy; {{year()}} &mdash;</div>
          <div><a href="https://www.thinkspatial.com.au"><ThinkSpatialLogo class="ts-footer-logo"/></a></div>
        </v-row>
      </v-col>
  </v-footer>
</template>
<script>
import ThinkSpatialLogo from 'assets/svg/ts-logo-white.svg';
export default {
  components: {
    ThinkSpatialLogo
  },
  data() {
    return {};
  },
  methods: {
    year: () => {
      return new Date().getFullYear();
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'assets/landing.scss';
a {
  color: #fff;
}

.footer {
  background: '#41281b';
  width: 100%;
}

.ts-logo {
  fill: #fff;
  height: 50px;
  display: inline-block;
  vertical-align: middle;
}

.dev-details > div {
  display: inline-block;
}
.footer-btn {
  font-size: 1.1em;
}

</style>
